<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data() {
      return {
           isRouterAlive: true
      }
  },
  methods: {
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  watch: {
    $route(to,from){
        // console.log(to)
        // this.$router.go(0)
        // console.log(to,from)
        // if(from.name=="Homepage"){
        //     for(let i=0;i<100;i++){
        //         clearInterval(i)
        //     }
        // }
    }
  }
}
</script>

<style lang="stylus">
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  width: 100%;
  height: 100%;
}
.containnnn {
    // background-color: #F9F8F8;
}

.contain {
    width: 1200px;
    border-radius: 10px;
    margin: auto;

    .containDiv {
        position: relative;
        top: -80px;
        border-radius: 10px;
        box-shadow: 0 58px 90px -14px #d4c7af;
        
        .titletitle{
            font-size: 18px;
            // border-left: solid 6px #448aca;
            // padding-left: 18px;
            height: 30px;
            line-height: 30px;
            margin: 0 0 68px 0;
        }

    }
}
/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: scale(0.95);
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue